// deck.gl のレイヤー配列を組み立てる唯一の場所。
//
// 役割: OSM ベースマップ（TileLayer）と、各データレイヤー（GeoJsonLayer）を合成して返す。
//       新しい描画種別を足すときはここに追加する。
// 関係: MapView.jsx が renderLayers(layers) を呼んで DeckGL に渡す。
//       layers の各要素は layer-store.js が保持する描画オブジェクト。
//
// 流用元: reference/deckgl-duckdb-template/src/Layers/index.js
import { BitmapLayer, GeoJsonLayer } from '@deck.gl/layers'
import { TileLayer } from '@deck.gl/geo-layers'
import { colorForValue } from '../viz/choropleth'

// OSM タイルのベースマップレイヤーを生成する。
function createBaseLayer() {
  return new TileLayer({
    id: 'osm-base',
    data: 'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',

    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north },
      } = props.tile

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north],
      })
    },
  })
}

// データレイヤーの定義配列を受け取り、ベースマップと合わせて deck.gl レイヤー配列を返す。
// layers: [{ layerId, featureCollection, color?, visible?, style? }]
// style?.type === 'choropleth' のとき、属性値→色（colorForValue）で塗り分ける。
export function renderLayers(layers = []) {
  const dataLayers = layers
    .filter((l) => l.visible !== false)
    .map((l) => {
      const color = l.color ?? [255, 140, 0]
      const fillColor = l.fillColor ?? color
      const strokeColor = l.strokeColor ?? color
      const choropleth = l.style?.type === 'choropleth'
      // コロプレス時は属性値で塗り分け（fill は半透明、line は不透明寄りに同色）。
      const getFillColor = choropleth
        ? (f) => colorForValue(f.properties?.[l.style.column], l.style)
        : [...fillColor, 160]
      const getLineColor = [...strokeColor, 255]
      return new GeoJsonLayer({
        id: `data-${l.layerId}`,
        data: l.featureCollection,
        pickable: true,
        stroked: true,
        filled: true,
        pointType: 'circle',
        getFillColor,
        getLineColor,
        // style 変更時にアクセサを再評価させる（deck.gl はアクセサをメモ化するため必須）。
        updateTriggers: {
          getFillColor: [l.style, fillColor],
          getLineColor: strokeColor,
        },
        lineWidthMinPixels: 1,
        getPointRadius: 5,
        pointRadiusUnits: 'pixels',
      })
    })

  return [createBaseLayer(), ...dataLayers]
}
